import { P2GLink } from '@parcel2go/core-ui';
import { useEffect, useState } from 'react';
import BrSplitter from '../../../../lib/helpers/BrSplitter';
import { LinkModel } from './LinkModel';
import printJS from 'print-js';
import LinkButton from '../../../LinkButton';
import { P2GLinkGroup } from '@parcel2go/core-ui';
import { useSmartSendApi } from '~/lib/api/smartsend/use-smartsend-api';
import { useLinkTitle } from './useLinkTitle';

export interface props {
  link: LinkModel;
  tag: string;
}

const Base64Link: React.FC<props> = (props) => {
  const { title } = useLinkTitle();
  const { getLabels } = useSmartSendApi();
  const [error, setError] = useState<boolean>(false);
  const [clicked, setClicked] = useState<boolean>(false);
  const [base64, setBase64] = useState<string>(null);
  const isHtml = props.link.Type.indexOf('HTML_BASE64') > -1;
  const maxAttempts = 5;
  const labelIntegrityLimit = 3;

  const onPrint = () => {
    if (printJS) {
      if (isHtml) {
        printJS({ printable: atob(base64), type: 'raw-html' });
      } else {
        printJS({ printable: base64, type: 'pdf', base64: true });
      }
    }
  };

  const getData = (attempt: number) => {
    getLabels(props.link.Href).then((r) => {
      if (
        r?.success === true &&
        r.result?.Labels?.length > 0 &&
        (r.result.FailedLabels === 0 || attempt >= labelIntegrityLimit)
      ) {
        setBase64(r.result.Labels[0]);
      } else {
        if (attempt < maxAttempts) {
          setTimeout(() => {
            getData(attempt + 1);
          }, 4000);
        } else {
          // Error
          setError(true);
          setTimeout(() => {
            setClicked(false);
            setBase64(null);
            setError(false);
          }, 5000);
        }
      }
    });
  };

  useEffect(() => {
    if (clicked && !base64) {
      getData(1);
    }
  }, [clicked]);

  useEffect(() => {
    if (base64) {
      onPrint();
    }
  }, [base64]);

  if (error) {
    return (
      <P2GLink>
        Label
        <br />
        Error
      </P2GLink>
    );
  }

  if (clicked) {
    return base64 ? (
      <>
        <P2GLink onClick={onPrint} href="javascript:void()">
          <BrSplitter label={title(props.link)} />
        </P2GLink>
        {!isHtml && (
          <P2GLinkGroup
            links={[
              <LinkButton
                variant="link"
                download={`${props.tag} \n ${title(props.link)}.pdf`}
                href={'data:application/pdf;base64,' + encodeURIComponent(base64)}
              >
                Download
              </LinkButton>
            ]}
            pt={1}
          />
        )}
      </>
    ) : (
      <P2GLink>
        Generating
        <br />
        Label...
      </P2GLink>
    );
  }

  return (
    <P2GLink onClick={() => setClicked(true)}>
      <BrSplitter label={title(props.link)} />
    </P2GLink>
  );
};

export default Base64Link;
